import { FC, ReactNode } from 'react';

interface ResultStatCardProps {
  icon: ReactNode;
  label: string;
  value: number;
  bgColor: string;
}

export const ResultStatCard: FC<ResultStatCardProps> = ({ icon, label, value, bgColor }) => {
  return (
    <div className="flex items-center gap-2 md:gap-3">
      <div
        className={`w-9 h-9 md:w-13.5 md:h-13.5 rounded-md md:rounded-xl ${bgColor} flex items-center justify-center shrink-0`}
      >
        {icon}
      </div>
      <div className="flex flex-col">
        <span className="text-[11px] md:[font-size:var(--fs-l5)]! text-(--neutral-black-NB400)! m-0! leading-tight!">
          {label}
        </span>
        <span className="[font-size:var(--fs-h5)]! md:[font-size:var(--fs-h3)]! font-bold text-(--neutral-black-NB1000)! m-0! leading-tight!">
          {value}
        </span>
      </div>
    </div>
  );
};
